<template lang="html">
  <div class="pmg-story">
    <span class="block block--blue"></span>
    <span class="block block--blue"></span>
    <span class="block block--blue"></span>
    <span class="block block--blue"></span>
    <span class="block block--red"></span>
    <span class="block block--red"></span>
    <span class="block block--gray"></span>
    <span class="block block--gray"></span>
    <span class="block block--gray"></span>

    <section class="pmg-story__story">
      <h2>the pmg story</h2>
      <p>PMG was founded by Brad and Terri Morris after Brad’s experience in the industry showed him that there was a better way to find success with mobile tours. Beginning with tours dedicated to outreach and education PMG found success with brands and companies that wanted to stand out and appreciated the clean and well managed approach that PMG took to building, launching, and operating a mobile tour.</p>
      <p>After successful tours in industries including auto racing, aeronautics and even space travel: PMG found its niche. The medical industry's demand for hands-on demonstrations, professional appearance and precise scheduling was a perfect fit for PMG. Since PMG’s first medical mobile tours over a decade ago, this has become their industry focus. PMG is chosen time and time again as the go-to medical tour resource by Fortune 500 companies. They value our uniquely professional image and managerial style. Our staff, equipment, and processes are all uniquely professional and skilled. Companies with products and clients that value quality (like those in the medical equipment industry) come to us when they need a mobile tour, and they come back consistently to repeat the success of their first tour.</p>
    </section>
  </div>
</template>

<script>
  export default {
    components: {
    },
    name: 'pmg-story',
    props: {
      heading: String,
      body: String
    },
    data () {
      return {
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .pmg-story {
    position: relative;
    margin-top: 3.125rem;
    padding: 5rem 1rem;
    background: url('/static/images/pmg-story__bg.jpg') no-repeat bottom center;
    background-size: cover;
    color: $white;
    @include breakpoint($md) {
      padding: 10rem 1rem 21.875rem 1rem;
    }

    span:nth-child(1) {
      top: -50px;
      left: 0;
      height: 50px;
      width: 100px;
    }

    span:nth-child(2) {
      top: 0;
      left: 0;
      height: 50px;
      width: 100px;
    }

    span:nth-child(3) {
      bottom: -50px;
      right: 0;
      height: 50px;
      width: 100px;
    }

    span:nth-child(4) {
      bottom: 0;
      right: 0;
      height: 50px;
      width: 100px;
    }

    span:nth-child(5) {
      top: 50px;
      left: 0;
      height: 50%;
      width: 100px;
    }

    span:nth-child(6) {
      bottom: 50px;
      right: 0;
      height: 50%;
      width: 100px;
    }

    span:nth-child(7) {
      top: 0;
      left: 100px;
      height: 50px;
      width: 70%;
    }

    span:nth-child(8) {
      bottom: 0;
      left: 0;
      height: 50px;
      width: 25%;
    }

    span:nth-child(9) {
      bottom: 0;
      right: 100px;
      height: 50px;
      width: 50%;
    }
  }

  .pmg-story__story {
    position: relative;
    margin: 0 auto;
    max-width: 68.750rem;
    padding: 2rem;
    border: 1px solid $white;
    z-index: 20;
    h2 {
      margin: 0;
      font-family: $montserrat;
      font-size: 2.750rem;
      font-weight: 700;
      color: $white;
      text-transform: uppercase;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/PmgStory.vue